import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import ApiConnectorCard from "../ApiConnectorCard"
import NexthinkConfigModal from "./NexthinkConfigModal"
import nexthinkLogo from "assets/images/connectors/nexthink-logo.png"

/**
 * Nexthink card for the developer portal
 * Allows configuring a centralized Nexthink connection for the entire platform
 */
const NexthinkCard = () => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  // TODO: Fetch the actual connection status from the API
  const [connectionStatus, setConnectionStatus] = useState("configure_now")

  const handleConfigure = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleSaveConfig = async (config) => {
    // TODO: Implement centralized configuration save
    console.log("Nexthink config saved:", config)
    setConnectionStatus("connected")
    setIsModalOpen(false)
  }

  return (
    <>
      <ApiConnectorCard
        serviceName={t("developer_portal:connectors.nexthink.name")}
        description={t("developer_portal:connectors.nexthink.description")}
        tag={t("developer_portal:connectors.nexthink.tag")}
        status={connectionStatus}
        // TODO: temporary desactivate
        // onStatusClick={handleConfigure}
        logoSource={nexthinkLogo}
        logoAlt="Nexthink"
        fillIcon={true}
      />
      <NexthinkConfigModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSaveConfig}
      />
    </>
  )
}

export default NexthinkCard
